import {Role} from 'src/openapi/models/Role';

export const hasEditRole = (userRoles: Array<Role>) =>
    userRoles.some((role: Role) => role === Role.ROLE_UDEDT_REVIEWER || role === Role.ROLE_UDEDT_APPROVER);
